import type { SVGProps } from "react";

const SvgCircleCheckOver = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_900_9490)">
      <path
        d="M18.3333 9.2333V9.99997C18.3323 11.797 17.7504 13.5455 16.6744 14.9848C15.5985 16.4241 14.0861 17.477 12.3628 17.9866C10.6395 18.4961 8.79771 18.4349 7.11206 17.8121C5.4264 17.1894 3.98721 16.0384 3.00913 14.5309C2.03105 13.0233 1.56649 11.24 1.68473 9.4469C1.80297 7.65377 2.49767 5.94691 3.66523 4.58086C4.83279 3.21482 6.41065 2.26279 8.16349 1.86676C9.91633 1.47073 11.7502 1.65192 13.3917 2.3833M18.3333 3.3333L10 11.675L7.5 9.17497"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_900_9490">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCircleCheckOver;
